import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const GetDemandPlanning = async (year) => {
  try {
    const response = await fetch(`${API_URL}DemandPlan/GetDemandPlanning/${year}/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch demand planning");
    return await response.json();
  } catch (error) {
    console.error("Error fetching demand planning:", error);
    return [];
  }
};

export const saveDemandPlan = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}DemandPlan/AddDemandPlanning`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to save demand plan');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const updateDemandPlan = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}DemandPlan/UpdateDemandPlanning`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update demand plan');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const fetchGradeRoles = async () => {
  try {
    const response = await fetch(`${API_URL}DemandPlan/GetGradeRoles`);
    if (!response.ok) throw new Error("Failed to fetch grade roles");
    return await response.json();
  } catch (error) {
    console.error("Error fetching grade roles:", error);
    return [];
  }
};

export const fetchRolesForDepartment = async (year, deptID) => {
  try {
    const response = await fetch(`${API_URL}DemandPlan/fetchRolesForDepartment/${year}/${deptID}`);
    if (!response.ok) throw new Error(`Failed to fetch roles. Status: ${response.status}`);
    const data = await response.json();
    if (!data || !Array.isArray(data)) throw new Error("Unexpected response structure.");
    return data;
  } catch (error) {
    console.error("Error fetching roles for department:", error.message);
    return [];
  }
};
